// Претензионная работа: /api/v2/claims/* (erp-backend, модуль src/claims).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchClaimsSummary() {
  const { data } = await api.get('claims/summary')
  return data
}

export async function fetchClaimsItems(segment) {
  const { data } = await api.get('claims/items', { params: segment ? { segment } : {} })
  return data
}

// Менеджер сообщает о простое: система сама регистрирует простой, формирует и отправляет акт.
export async function reportDowntime({ tripNumber, operation, comment }) {
  const { data } = await api.post('claims/downtime-reports', {
    trip_number: tripNumber,
    operation,
    comment: comment || null,
  })
  return data
}
